// デバイスサイズ
const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    mobile: '768px',
    laptop: '990px',
    laptopL: '1440px',
    ipadMini: '1024px',
    desktop: '2560px'
}

export const device = {
    mobileS: `(min-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(max-width: ${size.mobileL})`,
    mobile: `(max-width: ${size.mobile})`,
    laptop: `(max-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    ipadMini: `(min-width: ${size.ipadMini})`,
    desktop: `(min-width: ${size.desktop})`,
    ipadMiniA: `(max-width: ${size.mobile})`,
    ipadMiniB: `(min-width: ${size.mobile})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktop})`
};

